import fetchNspData from './fetch-nsp-data';

export default async function fetchNmePage(slug: string) {
  const res = await fetchNspData({ model: 'nme_page', slug });
  return res.nmePage;
}
